module.exports = __webpack_public_path__ + "static/media/galerija_2019 (6).620c6423.jpg";